import { Component, OnInit } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';
import { DataService, PartnerRecord, UserRecord } from '@core/services/data.service';
import { Filterable } from '@common/utilities/Filterable';
import { Lookup } from '@common/utilities/Lookup';
import { ModalService } from '@common/services/modal.service';
import { PartnerEditorComponent } from '@routes/editors/partner-editor/partner-editor.component';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { PartnersService } from '@core/services/partners.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { UsersService } from '@core/services/users.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

  constructor(private modal: ModalService, private usersService: UsersService, private partnersService: PartnersService, private sync: SynchronizationService) { }

  public partners: Filterable<PartnerRecord> = new Filterable<PartnerRecord>({
    extractor: i => [i.Name, i.Address, i.Phone],
    grouper: i => [{ name: 'Người phụ trách', option: i.DealerID > 0 ? this.dealer(i) : 'chưa có' }]
  });

  private users = new Lookup<UserRecord>(i => i.ID);

  public get loading(): boolean {
    return !this.sync.ready(PartnersService, UsersService) && this.partners.empty;
  }

  public synchronize() {

    this.partners.source = [];

    this.sync.when(PartnersService, UsersService).commit(() => {
      this.users.source = this.usersService.all;
      this.partners.source = this.partnersService.all.filter(i => i.ID > 3);
    });
  }

  ngOnInit(): void {
    this.synchronize();
  }

  public dealer(partner: PartnerRecord): string {
    
    return this.users.get(partner.DealerID, { ID: partner.DealerID, Username: '#' + partner.DealerID, Password: null, Roles: [] }).Username;
  }

  public extractor(field): SortableExtractor<PartnerRecord> {
    return {
      extract: i => {
        switch (field) {
          case 'Dealer': return this.dealer(i);
          default: return i[field];
        }
      }
    }
  }

  public edit(partner: PartnerRecord) {
    this.modal.show(PartnerEditorComponent, { state: { partner: partner } }).content.change.subscribe(updated => {
      this.partners.source = this.partners.source.filter(i => i != partner).union([updated]);
      this.partnersService.synchronize();    
    });
  }
}
